import React, { useEffect, useState } from 'react';
import './Auth.css';

const STORAGE_KEY = 'cookieConsent:v1';

const defaultConsent = {
  essential: true,
  analytics: false,
  advertising: false,
};

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);
  const [showPrefs, setShowPrefs] = useState(false);
  const [consent, setConsent] = useState(defaultConsent);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch {
      // If localStorage fails for any reason, fail open (show banner)
      setVisible(true);
    }
  }, []);

  const saveConsent = (values) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ ...values, decidedAt: new Date().toISOString() })
      );
    } catch {
      // If storage fails, still hide banner so UX isn't trapped
    }
    setVisible(false);
    setShowPrefs(false);
  };

  if (!visible) return null;

  return (
    <>
      <div className="gdpr-cookie-banner" role="dialog" aria-live="polite" aria-label="Cookie consent">
        <div className="gdpr-cookie-banner__inner">
          <div className="gdpr-cookie-banner__text">
            <strong>Cookies &amp; Privacy</strong>
            <p>
              We use cookies to keep the app running smoothly. With your permission, we also use
              cookies for analytics and limited ads to help fund hosting and development. You can
              accept all, reject non-essential, or manage your preferences.
            </p>
          </div>

          <div className="gdpr-cookie-banner__actions">
            <button
              type="button"
              className="gdpr-cookie-btn gdpr-cookie-btn--secondary"
              onClick={() => saveConsent({ ...defaultConsent })}
            >
              Reject Non-Essential
            </button>

            <button
              type="button"
              className="gdpr-cookie-btn gdpr-cookie-btn--primary"
              onClick={() => saveConsent({ essential: true, analytics: true, advertising: true })}
            >
              Accept All
            </button>

            <button
              type="button"
              className="gdpr-cookie-btn gdpr-cookie-btn--link"
              onClick={() => setShowPrefs(true)}
            >
              Manage
            </button>
          </div>
        </div>
      </div>

      {showPrefs && (
        <div className="gdpr-cookie-prefs__overlay" role="dialog" aria-modal="true" aria-label="Cookie preferences">
          <div className="gdpr-cookie-prefs__modal">
            <h3>Cookie Preferences</h3>

            <label className="gdpr-cookie-toggle gdpr-cookie-toggle--disabled">
              <input type="checkbox" checked readOnly />
              Essential cookies (required)
            </label>

            <label className="gdpr-cookie-toggle">
              <input
                type="checkbox"
                checked={consent.analytics}
                onChange={(e) => setConsent({ ...consent, analytics: e.target.checked })}
              />
              Analytics cookies
            </label>

            <label className="gdpr-cookie-toggle">
              <input
                type="checkbox"
                checked={consent.advertising}
                onChange={(e) => setConsent({ ...consent, advertising: e.target.checked })}
              />
              Advertising cookies
            </label>

            <div className="gdpr-cookie-prefs__actions">
              <button
                type="button"
                className="gdpr-cookie-btn gdpr-cookie-btn--primary"
                onClick={() => saveConsent(consent)}
              >
                Save Preferences
              </button>

              <button
                type="button"
                className="gdpr-cookie-btn gdpr-cookie-btn--secondary"
                onClick={() => setShowPrefs(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
